// src/utils/orderHider.js

const HIDDEN_ORDERS_KEY = 'hiddenOrders';

// Get hidden order IDs for a specific user
export function getHiddenOrders(username) {
  const stored = localStorage.getItem(HIDDEN_ORDERS_KEY);
  const parsed = stored ? JSON.parse(stored) : {};
  return parsed[username] || [];
}

// Hide an order for a specific user
export function hideOrderForUser(orderId, username) {
  const stored = localStorage.getItem(HIDDEN_ORDERS_KEY);
  const parsed = stored ? JSON.parse(stored) : {};
  const current = new Set(parsed[username] || []);
  current.add(orderId);
  parsed[username] = Array.from(current);
  localStorage.setItem(HIDDEN_ORDERS_KEY, JSON.stringify(parsed));
}

// Helper alias to match expected imports in screen
export const isOrderHidden = (orderId, username) =>
  getHiddenOrders(username).includes(orderId);

export const hideOrder = (orderId, username) =>
  hideOrderForUser(orderId, username);
